export default "__VITE_ASSET__DKA$OMT6__"